import React from "react"
import { connect } from "react-redux"
import OpenOrderQRCode from "../../components/shop/open-order-qr-code"

const mapStateToProps = state => ({
  isOpen: state.currentShop.openOrders.isQRModalOpen,
  paymentUrl: `//${window.location.host}/orders/${state.currentShop.openOrders.currentId}`
})

const mapDispatchToProps = dispatch => ({
  onClose: () => {
    dispatch({type: "ORDER.TOUCHLESS_ORDER_CLOSED"})
  }
})

export default connect(mapStateToProps, mapDispatchToProps)(OpenOrderQRCode)

